import { render } from "./ManagerStudentBar.vue?vue&type=template&id=e6ed7144&scoped=true"
import script from "./ManagerStudentBar.vue?vue&type=script&lang=js"
export * from "./ManagerStudentBar.vue?vue&type=script&lang=js"

import "./ManagerStudentBar.vue?vue&type=style&index=0&id=e6ed7144&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6ed7144"]])

export default __exports__